import React from 'react';
import StatusPageLayout from './StatusPageLayout';

const ErrorFallback = () => {
    return (
        <StatusPageLayout
            title="An error occurred"
            message={
                <>
                    We are sorry about this. <br />
                    Please refresh the page.
                </>
            }
        />
    );
};

export default ErrorFallback;
